import React from "react";
import Modal from "../Modal.jsx";

export default class PmoDashboard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal title="Prime Minister Office Dashboard" id="pmo" onClose={this.props.onClose}>
          <img
              src="/img/portfolio/pmo.png"
              className="img-responsive img-centered"
              alt=""
          />
        <p>
            The PMO Dashboard was built for a United Arab Emirates government project in 2020.
            It helps teams track project progress, spending, and other delivery information in one place.

        </p>

        <ul className="list-inline item-details">
          <li>
            Client:
            <strong>
              &nbsp;Motius
            </strong>
          </li>
          <li>
            Date:
            <strong> 2020 </strong>
          </li>
        </ul>
      </Modal>
    );
  }
}
